import React from "react";

function SvgIconWarningWhite(props) {
  return (
    <svg width={16} height={16} {...props}>
      <path
        fill="#FFF"
        d="M8.664.162c.291.145.528.38.673.671l6.504 12.996a1.499 1.499 0 01-1.343 2.17H1.502A1.501 1.501 0 01.158 13.83L6.649.835A1.503 1.503 0 018.664.162zM8.004 12a1 1 0 00-1.002 1 1.001 1.001 0 002.005 0c0-.552-.45-1-1.003-1zm.003-7c-.557 0-1.005.448-1.005 1v4a1 1 0 001 1c.557 0 1.005-.448 1.005-1V6a1 1 0 00-1-1z"
      />
    </svg>
  );
}

export default SvgIconWarningWhite;
